import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_auto-paint-brisbane/artifacts/37p3il2l_Screenshot%202025-04-27%20024102.png";

export const QuoteCTA = () => {
  const navigate = useNavigate();

  return (
    <section id="quote" className="py-24 md:py-32 bg-[#050505]" data-testid="quote-cta">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-to-br from-[#3b82f6]/10 to-transparent border border-[#3b82f6]/20 p-12 md:p-16 text-center"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 mb-8">
            <img src={LOGO_URL} alt="Velocity Paint and Panel" className="w-full h-full object-contain" />
          </div>
          
          <h2 className="font-heading text-4xl sm:text-5xl uppercase tracking-tight text-white mb-4">
            Ready to Transform<br />Your Ride?
          </h2>
          
          <p className="text-zinc-400 font-body text-base max-w-lg mx-auto mb-8">
            Get a free, no-obligation quote for your vehicle. Tell us what you need and we'll get back to you within 24 hours.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => navigate('/quote')}
              className="group flex items-center gap-3 bg-[#3b82f6] text-white font-heading text-sm tracking-[0.15em] uppercase px-8 py-4 hover:bg-[#3b82f6]/80 transition-colors cursor-pointer border-none"
            >
              Get a Free Quote
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
            
            <button
              onClick={() => navigate('/book')}
              className="flex items-center gap-3 bg-transparent border border-white/20 text-white font-heading text-sm tracking-[0.15em] uppercase px-8 py-4 hover:border-white/40 transition-colors cursor-pointer"
            >
              Book Appointment
            </button>
          </div>
          
          <p className="text-zinc-600 text-xs font-body mt-6">
            Or call us directly: <a href="tel:+61450645926" className="text-[#3b82f6] hover:underline">0450 645 926</a>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default QuoteCTA;
